/* Variant NYC — "Complete the look" in the bag drawer.
   Pairs the Waxed Shorts and the Cream Henley. The 15% off is the automatic
   "COMPLETE THE LOOK" discount (buy the shorts, 15% off the Henley), applied at checkout. */
(function () {
  var dataEl = document.getElementById('v-ctl-data');
  var box = document.querySelector('[data-ctl]');
  var list = document.querySelector('[data-cart-items]');
  if (!dataEl || !box || !list) return;
  var D; try { D = JSON.parse(dataEl.textContent); } catch (e) { return; }
  var ROOT = ((window.VNYC && window.VNYC.root) || '/').replace(/\/$/, '');
  var OFF = 0.15;

  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML.replace(/"/g, '&quot;'); }
  function money(c) { var n = c / 100; return '$' + (n % 1 === 0 ? n.toFixed(0) : n.toFixed(2)); }

  function refreshDrawer() {
    var b = document.createElement('button');
    b.type = 'button'; b.hidden = true; b.setAttribute('data-cart-open', '');
    box.appendChild(b); b.click(); b.remove();
  }

  function offer(p, line) {
    var sizes = p.variants.map(function (v) {
      return '<button type="button" data-ctl-add="' + v.id + '"' + (v.available ? '' : ' disabled aria-label="' + esc(v.title) + ' sold out"') + '>' + esc(v.title) + '</button>';
    }).join('');
    return '<a class="v-ctl-img" href="' + esc(p.url) + '">' + (p.image ? '<img src="' + esc(p.image) + '" alt="" loading="lazy">' : '') + '</a>' +
      '<div class="v-ctl-b"><span class="v-ctl-k">Complete the look</span>' +
      '<span class="v-ctl-t">' + esc(p.title) + '</span>' +
      '<span class="v-ctl-o">' + line + '</span>' +
      '<div class="v-ctl-sz" role="group" aria-label="Add ' + esc(p.title) + ' in size">' + sizes + '</div>' +
      '<p class="v-ctl-m" data-ctl-msg role="status" aria-live="polite"></p></div>';
  }

  function draw(cart) {
    var hasS = false, hasH = false;
    (cart.items || []).forEach(function (it) {
      if (it.product_id === D.shorts.id) hasS = true;
      if (it.product_id === D.henley.id) hasH = true;
    });
    box.classList.remove('v-ctl--done');
    if (!cart.item_count || (!hasS && !hasH)) { box.hidden = true; box.innerHTML = ''; return; }
    if (hasS && hasH) {
      box.classList.add('v-ctl--done');
      box.innerHTML = '<span>Complete the look: 15% off your Henley is applied at checkout.</span>';
    } else if (hasH) {
      box.innerHTML = offer(D.shorts, money(D.shorts.price) + ' &middot; add them and get 15% off your Henley');
    } else {
      var p = D.henley.price;
      box.innerHTML = offer(D.henley, '<s>' + money(p) + '</s>' + money(Math.round(p * (1 - OFF))) + ' with your shorts');
    }
    box.hidden = false;
  }

  function sync() {
    fetch(ROOT + '/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); }).then(draw).catch(function () { box.hidden = true; });
  }

  new MutationObserver(sync).observe(list, { childList: true });

  box.addEventListener('click', function (e) {
    var b = e.target.closest('[data-ctl-add]');
    if (!b || b.disabled) return;
    var p = D.shorts.variants.some(function (v) { return String(v.id) === b.getAttribute('data-ctl-add'); }) ? D.shorts : D.henley;
    var item = { id: Number(b.getAttribute('data-ctl-add')), quantity: 1 };
    if (p.preorder && D.dispatch) item.properties = { Dispatch: D.dispatch };
    box.querySelectorAll('[data-ctl-add]').forEach(function (x) { x.disabled = true; });
    var msg = box.querySelector('[data-ctl-msg]'); if (msg) msg.textContent = 'Adding…';
    fetch(ROOT + '/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [item] })
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(refreshDrawer)
      .catch(function (err) {
        if (msg) msg.textContent = (err && (err.description || err.message)) || 'Could not add. Please try again.';
        sync();
      });
  });
})();
